import { WeatherStationDailyAverageModel } from '../models/weather-station-daily-average';

export class WeatherStationDailyAverageAdapter {
  static fromApi(response: any): WeatherStationDailyAverageModel {
    const data = response.data || response;

    return {
      tempAvg: data.tempAvg,
    };
  }
}
